/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateShiftCoverRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {CreateShiftCoverResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const createShiftCover = (request: CreateShiftCoverRequest, options?: CashRequestOptions) => post<CreateShiftCoverRequest, CreateShiftCoverResponse>("/2.0/cash/create-shift-cover", request, {...options, rejectOnError: true })